module.exports = __webpack_public_path__ + "img/wm-introduction.9eb97721.png";